/**
 * Main entry point for KiSite
 */

import "./styles/main.css";

import "./components/workspace-app.js";
import "./components/project-detail.js";
import "./components/viewer-panel.js";
import "./components/project-gallery.js";

import "./lib/router.js";

console.log("KiSite initialized");
